import React, { useState } from 'react'
import {
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
    ModalCloseButton,
    ModalHeader,
    PinInput,
    PinInputField,
    Text, 
    Divider,
    Flex,
    Box,
    Button,
    useToast
  } from "@chakra-ui/react";
  import axios from 'axios'
import { useParams } from 'react-router-dom';
import { Auth } from './Auth';
  
const OtpDeliveryBoy = ({ isOpen2, onClose2, deliveredRender, mobile}) => {
    const [digit1, setDigit1] = useState("");
    const [digit2, setDigit2] = useState("");
    const [digit3, setDigit3] = useState("");
    const [digit4, setDigit4] = useState("");
    const [isVerifyBtn, setIsVerifyBtn] = useState(false)
    const [invalidOtp, setInvalidOtp] = useState(false)

    console.log(mobile, 'xxxxxxxxxx')
    const toast = useToast()
    const { id } = useParams()
    // const sampleOTP = '1234'
    const otp = digit1 + digit2 + digit3 + digit4
    const verifyHandler = () => {
        setIsVerifyBtn(true)    
 
      // Verify otp msg91
      let config5 = {
        method: 'get',
        maxBodyLength: Infinity,
        // url: `${process.env.REACT_APP_RALCO_API_URL}/api/msg91/verify-otp?otp=${otp}&mobile=918051542244`, //mobile
        url: `${process.env.REACT_APP_RALCO_API_URL}/api/msg91/verify-otp?otp=${otp}&mobile=${Number(mobile.split('+')[1])}`, //mobile
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': Auth()
        },
      };
      
      axios.request(config5)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
        setInvalidOtp(false)
        // change order status to delivered with update ticket
        if(response.data.type === "success") {
   
        let data = JSON.stringify({
          "orderStatusId": `ORDER_DELIVERED`
        });
        
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${id}`,
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': Auth()
          },
          data : data
        };
        
        axios.request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          toast({
            title: `Order Delivered`,
            status: 'success',
            duration: 4000,
            isClosable: true,
            position: 'top'
          })
         
          deliveredRender()
  
           // ################# AFTER ORDER TICKET CREATION ###########################
            // GET TICKET
          // let getTicket = {
          //   method: 'get',
          //   maxBodyLength: Infinity,
          //   url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/get-ticket-with-order-id/${id}`,
          //   headers: { 
          //     'Content-Type': 'application/json',
          //     'Authorization': Auth()
          //   },
          // };
  
          // axios.request(getTicket)
          // .then((response) => {
          //   // console.log(JSON.stringify(response.data));
          //   const data = response.data
          //   let ticketObj = data.filter((x) => ((x.shopifyOrderId === id) && (x.ticketObj.custom_fields.cf_ticket_type === "ORDER_TICKET") &&
          //  (x.ticketObj.custom_fields.cf_status === "ORDER_PICKED_UP")))
          //   let ticketId = ticketObj[0]?.ticketId
           
  
          //   let myPayload = JSON.stringify({
          //     "freshdesk": {
          //       "custom_fields": {
          //         "cf_ticket_type": "ORDER_TICKET",
          //         "cf_status": "ORDER_DELIVERED"
          //       }
          //     }
          //   });
          //   // Update Ticket
          //   let config = {
          //     method: 'put',
          //     maxBodyLength: Infinity,
          //     url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/update-ticket/${ticketId}`,
          //     headers: { 
          //       'Content-Type': 'application/json',
          //       'Authorization': Auth()
          //     },
          //     data : myPayload
          //   };
            
          //   axios.request(config)
          //   .then((response) => {
          //     // console.log(JSON.stringify(response.data));
          //     console.log('Ticket Updated Successfullyyy --- ORDER #####################################')
              
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //   });
  
  
          // })
          // .catch((error) => {
          //   console.log(error);
          // });

        })
        .catch((error) => {
          console.log(error);
          toast({
            title: `Something went wrong please try again`,
            status: 'error',
            duration: 4000,
            isClosable: true,
            position: 'top'
          })
        });
      
        // ----------
           onClose2()
      }else if(response.data.type === "error"){
        setInvalidOtp(true)
        setIsVerifyBtn(false)
      }
      })
      .catch((error) => {
        console.log(error);
        setInvalidOtp(true)
        setIsVerifyBtn(false)
      });

    }

    
    return (
    <Modal
      isOpen={isOpen2}
      onClose={onClose2}
    >
        <ModalOverlay/>
        <ModalContent height={'45vh'} width={'85%'}>
          <ModalHeader pb={0}>
            <ModalCloseButton mt={5}/>
          <ModalHeader textAlign={'center'}>Verify OTP</ModalHeader>
          </ModalHeader>
          <Divider/>
          <ModalBody >
              <Flex justifyContent={'center'} w={'100%'} mt={2}>
                <PinInput isInvalid={invalidOtp}>
                  <PinInputField value={digit1} onChange={(e) => {
                    setDigit1(e.target.value)
                    if(e.target.value !== ""){
                      setInvalidOtp(false)}}} />
                    
                  <PinInputField value={digit2} onChange={(e) => {
                    setDigit2(e.target.value)
                    if(e.target.value !== ""){
                      setInvalidOtp(false)}
                    }}/>
                  <PinInputField value={digit3} onChange={(e) => {
                    setDigit3(e.target.value)
                    if(e.target.value !== ""){
                      setInvalidOtp(false)}
                    }}/>
                  <PinInputField value={digit4} onChange={(e) => {
                    setDigit4(e.target.value)
                    if(e.target.value !== ""){
                      setInvalidOtp(false)}
                    }}/>
                </PinInput>
              </Flex>
              {invalidOtp &&
              <Box w={'38%'} m={'auto'}>
                <Text fontSize={'13px'} color={'red.500'}>Invalid OTP</Text>
              </Box>}
              <Box textAlign={'center'} mt={2}>
              <Button
                  isDisabled={otp.length !== 4}
                  isLoading={isVerifyBtn}
                  loadingText='Verifying'
                  colorScheme='whatsapp'
                  px={14}
                  h={'30px'}
                  onClick={verifyHandler}
                >
                  Verify
                </Button>
              </Box>
              {/* <Box textAlign={'center'} mt={'1px'}>
                <Text fontSize={'13px'} color='#F15412' _hover={{cursor: 'pointer'}} fontWeight={'semibold'} textDecoration={'underline'}>Resend OTP</Text>
              </Box> */}
          </ModalBody>
        </ModalContent>
     </Modal>
    )
}

export default OtpDeliveryBoy